define('core/utils/url/serializeArgs',['require','exports','module','core/utils/collection/each'],function (require, exports, module) {
    'use strict';

    var each = require('core/utils/collection/each');

    /**
     * Serializes object containing name:value pairs into a query string.
     *
     * @param {Object} params - The parameters to serialize.
     * @returns {string} - The query string.
     */
    module.exports = function serializeArgs(params) {
        var pcs = [];
        each(params, function (val, key) {
            if (val !== undefined)
                pcs.push(encodeURIComponent(key) + (val === null ? '' : '=' + encodeURIComponent(val)));
        });
        return pcs.join('&');
    };
});

